import { ModalsProvider as Provider } from '@mantine/modals';
import type { ReactNode } from 'react';
import { GameLimitsModal } from '../ui/GameLimitsModal';
import { HowToPlayModal } from '../ui/HowToPlayModal';

const modals = {
  howToPlay: HowToPlayModal,
  gameLimits: GameLimitsModal,
};

declare module '@mantine/modals' {
  export interface MantineModalsOverride {
    modals: typeof modals;
  }
}
export const ModalsProvider = ({ children }: { children: ReactNode }) => {
  return <Provider modals={modals}>{children}</Provider>;
};
